import hotelView1 from "@/assets/hotel-view-1.png";
import hotelView2 from "@/assets/hotel-view-2.png";
import hotelView3 from "@/assets/hotel-view-3.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";
import YouTubeFacade from "./YouTubeFacade";

const images = [
  { src: hotelView1, alt: "Hotel Quelle Bad Ragaz" },
  { src: hotelView2, alt: "Bad Ragaz Panorama" },
  { src: hotelView3, alt: "Bad Ragaz" },
];

const HomeApartmentGallery = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  return (
    <section className="hotel-section bg-background">
      <div className="hotel-container">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
          <p className="hotel-caption text-accent mb-4">{get("gallery_caption") || t.homeGallery.caption}</p>
          <h2 className="hotel-heading text-foreground mb-6">{get("gallery_heading") || t.homeGallery.heading}</h2>
        </div>
        <div className="grid grid-cols-3 gap-2 md:gap-6 mb-6 md:mb-8">
          {images.map((img) => (
            <div key={img.alt} className="rounded-lg overflow-hidden shadow-soft group">
              <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-32 md:h-64 object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
          ))}
        </div>
        <div className="rounded-lg overflow-hidden shadow-soft aspect-video">
          <YouTubeFacade videoId="0dR9_lVnfwo" title="Hotel Quelle Apartments" />
        </div>
      </div>
    </section>
  );
};

export default HomeApartmentGallery;
